// extracted by mini-css-extract-plugin
export default {"dock":"SwHeightRockTypeDock_dock__ei5T7","header":"SwHeightRockTypeDock_header__71pE+","heading":"SwHeightRockTypeDock_heading__+cZ1R","body":"SwHeightRockTypeDock_body__TGuY9"};